import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  styleUrls: ['./hint.component.scss']
})
export class HintComponent implements OnInit {

  @Input() content: string;
  @Input() icon: string;
  @Input() rounded: boolean;
  @Input() arrowDown: boolean;
  @Input() arrowUp: boolean;
  @Input() arrowLeft: boolean;
  @Input() size: HintSize;

  constructor() { }

  ngOnInit() {
  }

}

export enum HintSize {
  SMALL = 'SMALL',
  NORMAL = 'NORMAL',
}
